<template>
    <div  id="jitsi_meet" class="jitsi-iframe-container"></div>
</template>
<script>
import i18n from "@/i18n";
export default {
    name: "Jitsi",
    props: {
        meta: {
            type: Object,
            default: null
        },
        consumer: {
            type: Object,
            default: null
        }
    },
    mounted() {
        this.showNotification();
        this.initialiseJitsi();
    },
    methods: {
        initialiseJitsi(){
            const domain = 'meet.jit.si';
            const options = this.jitsiOptions();
            const api = new JitsiMeetExternalAPI(domain, options);
        },
        jitsiOptions(){
            const parentNode = document.getElementById("jitsi_meet") ;
            const meeting_id = /[^/]*$/.exec(this.meta.meeting_url)[0];
            return {
                    roomName: meeting_id,
                    width: "100%",
                    height: "100%",
                    userInfo: {
                        email: this.consumer.email,
                        displayName: this.consumer.name
                    },
                    configOverwrite: { startWithAudioMuted: true,startWithVideoMuted:true,prejoinPageEnabled: false,disableDeepLinking: true},
                    interfaceConfigOverwrite: { SHOW_CHROME_EXTENSION_BANNER: false },
                    parentNode: parentNode
            };
        },

        /** Show notification: Event is about to start */
        showNotification() {
            this.$store.dispatch("app/showSupportNotification", {
                screener_id: this.meta.screener_id,
                message: this.meta.title + i18n.t("screener.meeting.is_about_to_stream")
            });
        }
    }
}
</script>
<style scoped>
.jitsi-iframe-container {
  width: 100%;
  height: 60vh;
}
</style>
